import { Component, Input } from '@angular/core';
import { RatingBand } from 'src/app/models/rating-band.model';

@Component({
  selector: 'app-legend-card',
  templateUrl: './legend-card.component.html',
  styleUrl: './legend-card.component.scss'
})
export class LegendCardComponent {

  @Input()
  public items: RatingBand[] = [];
}
